import React from 'react';
import { Provider } from 'react-redux';
import store from '../../store/store';
import ProductsNav from './ProductsNav';

export default function Products() {
  return (
    <Provider store={store}>
      <ProductsNav />
    </Provider>
  );
}
